// extracted by mini-css-extract-plugin
export default {"button":"styles_button__pdMgH","text":"styles_text__OVZqI"};